var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",class:{active: _vm.card.rate > 0}},[_c('div',{staticClass:"title line-clamp-1"},[_vm._v(_vm._s(_vm.card.name))]),_c('div',{staticClass:"state"},[_vm._v(_vm._s(_vm.card.rate > 0 ? '已学习' : '未学习'))])])}
var staticRenderFns = []

export { render, staticRenderFns }